<template>
  <div class="atwood-machine-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>a = g · (m2 - m1) / (m1 + m2)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Pulley -->
          <circle cx="200" cy="50" r="20" fill="#444" stroke="#888" stroke-width="2" />
          <circle cx="200" cy="50" r="3" fill="#fff" />

          <!-- String -->
          <line x1="180" y1="50" x2="180" :y2="100 + offset" stroke="#aaa" />
          <line x1="220" y1="50" x2="220" :y2="100 - offset" stroke="#aaa" />

          <!-- Weights -->
          <g :transform="`translate(180, ${100 + offset})`">
             <rect x="-15" y="0" width="30" height="30" :fill="m1Color" stroke="#fff" />
             <text x="-8" y="20" fill="#fff" font-size="10">m1</text>
          </g>
          <g :transform="`translate(220, ${100 - offset})`">
             <rect x="-15" y="0" width="30" height="30" :fill="m2Color" stroke="#fff" />
             <text x="-8" y="20" fill="#fff" font-size="10">m2</text>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>加速度 a: {{ acceleration.toFixed(2) }} m/s²</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>质量 m1: {{ m1 }} kg</label>
             <el-slider v-model="m1" :min="1" :max="20" size="mini"></el-slider>
          </div>
          <div class="row">
             <label>质量 m2: {{ m2 }} kg</label>
             <el-slider v-model="m2" :min="1" :max="20" size="mini"></el-slider>
          </div>
          <div class="row">
             <el-button type="primary" size="mini" @click="reset">重置位置</el-button>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>阿特伍德机是验证牛顿第二定律的经典实验。两个质量不同的物体通过定滑轮连接。由于重力差，系统会产生恒定的加速度。通过改变两个砝码的质量比，可以精确研究力、质量与加速度之间的关系，同时它是忽略滑轮质量和摩擦的理想力学模型。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AtwoodMachineViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      m1: 5,
      m2: 10,
      offset: 0,
      velocity: 0,
      timer: null
    }
  },
  computed: {
    acceleration() {
      return 9.8 * (this.m1 - this.m2) / (this.m1 + this.m2);
    },
    m1Color() { return this.m1 > this.m2 ? '#ff4757' : '#2ed573'; },
    m2Color() { return this.m2 > this.m1 ? '#ff4757' : '#2ed573'; }
  },
  methods: {
    update() {
      this.velocity += this.acceleration * 0.05;
      this.offset += this.velocity;
      if (this.offset > 60) this.offset = 60;
      if (this.offset < -60) this.offset = -60;
      this.timer = requestAnimationFrame(this.update);
    },
    reset() {
      this.offset = 0;
      this.velocity = 0;
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.atwood-machine-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
